import { createContext, useContext, useMemo, useState } from "react";

const CollectedOrderDatasValueContext = createContext();
const CollectedOrderDatasActionsContext = createContext();

export function CollectedOrderDatasContextProvider({ children }) {
    const [collectedOrderDatas, setCollectedOrderDatas] = useState([]);

    const collectedOrderDatassActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setCollectedOrderDatas(newValues);
                },
                setValue: setCollectedOrderDatas
            }
        },
        []
    )

    return (
        <>
            <CollectedOrderDatasActionsContext.Provider value={{ collectedOrderDatas: collectedOrderDatassActions }}>
                <CollectedOrderDatasValueContext.Provider value={{ collectedOrderDatas }}>
                    {children}
                </CollectedOrderDatasValueContext.Provider>
            </CollectedOrderDatasActionsContext.Provider>
        </>
    );
}

export function useCollectedOrderDatasValueContextHook(props) {
    const value = useContext(CollectedOrderDatasValueContext);

    if (value === undefined) {
        throw new Error('useCollectedOrderDatasValueContextHook should be used within CollectedOrderDatasValueContext');
    }

    return {
        collectedOrderDatas: value.collectedOrderDatas
    };
}

export function useCollectedOrderDatasActionsContextHook(props) {
    const value = useContext(CollectedOrderDatasActionsContext);

    if (value === undefined) {
        throw new Error('useCollectedOrderDatasActionsContextHook should be used within CollectedOrderDatasActionsContext');
    }

    return {
        collectedOrderDatas: {
            onSet: value.collectedOrderDatas.onSet,
            setValue: value.collectedOrderDatas.setValue
        }
    };
}